import { Control } from "react-hook-form";
import { FormInput } from "../../../../../../components/ui/Input/FormInput/FormInput";
import { FormInputNumber } from "../../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormSelect } from "../../../../../../components/ui/Input/FormSelector/FormSelect";
import { PACKAGING_LEVELS } from "../../../../../../config/constants";
import { validateCultivationNumber } from "../../../../../../utils/utils";
import { PACKAGING_NAME_MAX_LENGTH } from "../packagingLevel.config";
import { PACKAGING_GATE, PackagingGate } from "../packagingLevel.types";

const numberValidation = {
  validate: {
    valueCheck: (v: any) => validateCultivationNumber(v)
  }
};

export interface PackagingMachineryFieldsProps {
  control: Control<any>;
  lockStatus: boolean;
  gate: PackagingGate;
  wasteManagementOptions: any[];
  showPlaceholders?: boolean;
}

const PackagingMachineryFields = ({
  control,
  lockStatus,
  gate,
  wasteManagementOptions,
  showPlaceholders = false
}: PackagingMachineryFieldsProps) => (
  <div className="tw-space-y-3">
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3">
      <FormInput
        control={control}
        name="packagingMethodName"
        label="Packaging Step Name"
        required
        disabled={lockStatus}
        placeholder={showPlaceholders ? "e.g., Filling" : undefined}
        errorMessage="Packaging step name is required"
        rules={{
          validate: (value: string) =>
            value?.length <= PACKAGING_NAME_MAX_LENGTH ||
            `Maximum ${PACKAGING_NAME_MAX_LENGTH} characters allowed`
        }}
      />
      <FormInput
        control={control}
        name="packagingMachine"
        label="Packaging Machinery Name"
        disabled={lockStatus}
        placeholder={showPlaceholders ? "e.g., Filler X200" : undefined}
        rules={{
          validate: (value: string) =>
            !value ||
            value?.length <= PACKAGING_NAME_MAX_LENGTH ||
            `Maximum ${PACKAGING_NAME_MAX_LENGTH} characters allowed`
        }}
      />
      <FormSelect
        control={control}
        name="packagingLevel"
        label="Packaging Level"
        placeholder="Select Level"
        options={PACKAGING_LEVELS}
        disabled={lockStatus}
      />
    </div>

    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-3 tw-items-end">
      <FormInputNumber
        control={control}
        name="energy"
        label="Energy (kWh)"
        placeholder="Energy"
        disabled={lockStatus}
        rules={numberValidation}
        required={gate === PACKAGING_GATE.PROCESS}
        errorMessage="Energy is required"
      />
      <FormInputNumber
        control={control}
        name="capacity"
        label="Capacity (pk/hr)"
        placeholder="Capacity"
        disabled={lockStatus}
        rules={numberValidation}
      />
      <FormInputNumber
        control={control}
        name="waste"
        label="Waste (pk/hr)"
        placeholder="Waste"
        disabled={lockStatus}
        rules={numberValidation}
      />
      <FormSelect
        control={control}
        name="wasteManagementMethod"
        label="Waste Management"
        placeholder="Select waste management"
        options={wasteManagementOptions}
        disabled={lockStatus}
      />
    </div>
  </div>
);

export default PackagingMachineryFields;
